<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/13cLVU7/tc-custom/9781460380222.jpg?1705766093852" alt="This image is the cover for the book Deceptions and Desires"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Deceptions and Desires
      </h1>
      <p class="bookDescription body article font2">
        <i>Well, if I'm going to die, at least it's under a man who looks like that. And feels like this.</i><br/><br/>Funny the things that leap to mind when your apartment has just exploded in front of you. Jane Greene wasn't always her name. But she left the original behind the night she finally killed her vicious mobbed-up husband and then bolted.<br/><br/>Eight years lying low. Now the only thing standinglying, reallybetween her and a crew of vengeful Abruzzi family goons is a man. He says his name is Leo. He wants to save her even more than he just plain wants her. Adrenaline and lust are powerful allies. So they run, together.<br/><br/>But more potent than the sheen of sweat between Jane and Leo is a secret. A past that one remembers with grief and regret, and that the other can't begin to guess. Both know that the Abruzzis cannot be stopped. That a tryst is not trust. And that no one will escape unscathed.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Melinda Di Lorenzo, Melinda Di Lorenzo
      </h2>
      
      <p class="authorDescription body article">Melinda writes happily-ever-afters, one page at a time, from her coastal home in&#160;British Columbia, Canada. She lives with her own handsome hero of a husband and their three children. When not writing, she can be found at the soccer field - playing or watching - or curled up with a good book.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0ff851f4